import { ToggleObject } from '@vwfs-bronson/bronson-react';
import { TFunction } from 'i18next';
import React from 'react';
import { TrackableComponent } from '../../../components/TrackableComponent/TrackableComponent';

interface OwnProps {
  showMoreButtonVisible: boolean;
  loadMore: () => void;
  t: TFunction;
}

export const LoadMoreButton: React.FC<OwnProps> = ({ showMoreButtonVisible, loadMore, t }) => {
  const loadMoreAndBlur = (): void => {
    loadMore();

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  if (!showMoreButtonVisible) {
    return null;
  }

  return (
    <div className="u-pt-large u-text-center">
      <TrackableComponent trackingComponent="button" trackingFunction="buttonShowFurtherDealers">
        <ToggleObject
          id="dealer-selection-load-more-toggle"
          className="c-show-more__button"
          iconClassName="c-show-more__icon"
          hidden={true}
          labelHidden={t('results.show-more-button')}
          labelUnhidden={t('results.show-more-button')}
          onClick={() => loadMoreAndBlur()}
          testId="dealer-selection-load-more-toggle"
          small
          iconViaCss
          iconReversed
          link
        />
      </TrackableComponent>
    </div>
  );
};
